import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/StoresService';
import { StoresMap } from '~domain/entities/StoresMap';
import { awaitMapThenFitBoundsOrPan } from '../../../utils/MapUtils';
import { StoresRepository } from '~repositories/StoresRepository';
import {
    BuyOnlinePickupInStoreFetchDataStrategy,
    IFetchDataStrategy
} from 'src/internal/strategies/StoresFetchDataStrategies';
import { UserLocationRepository } from '~repositories/UserLocationRepository';

export class BopisFilterToggledUseCase {
    private fetchDataStrategy: IFetchDataStrategy;
    private userLocationRepository: UserLocationRepository;
    private storesMap: StoresMap;
    private storesRepository: StoresRepository;

    constructor(
        fetchDataStrategy: IFetchDataStrategy = new BuyOnlinePickupInStoreFetchDataStrategy()
    ) {
        this.fetchDataStrategy = fetchDataStrategy;
        this.userLocationRepository = diContainer.get(serviceNames.userLocationRepository);
        this.storesMap = diContainer.get(serviceNames.storesMap);
        this.storesRepository = diContainer.get(serviceNames.storesRepository);
    }

    public execute = async () => {
        const geolocation = this.userLocationRepository.userLocation.geolocation;

        await this.fetchDataStrategy.loadStores(geolocation);

        awaitMapThenFitBoundsOrPan(
            this.storesMap.map,
            this.storesRepository.stores.length,
            geolocation
        );
    };
}
